export const DetailsComponentTabsData = [
  { tab: 'Related-SubCommunities' }
];
